<ion-header translucent>
  <ion-toolbar [ngClass]="{'start-header': isStartPage}">

    <ion-buttons slot="start">
      <ion-menu-button color='secondary' auto-hide="false" *ngIf="isStartPage"></ion-menu-button>
      <ion-back-button color="secondary" icon="arrow-back" text='' defaultHref="/" *ngIf="!isStartPage"></ion-back-button>
    </ion-buttons>

    <ion-title color="secondary" class="ion-text-center ion-text-capitalize" *ngIf="title">
      {{ title }}
    </ion-title>
    <ion-title *ngIf="iconTitle" class="ion-text-center">
      <img alt="logo" id="header_logo" height="25" [src]="iconTitle">
    </ion-title>

    <ion-buttons slot="end" class="endButtonClass">
      <ion-button style="zoom:1.3;" [disabled]='endButtonDisable' (click)="onClick($event)">
        <ion-icon slot="icon-only" [src]="endButtonImg" [name]='endButtonIcon' [hidden]="endButtonHidden" color="primary"></ion-icon>
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>
